import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { SecureRoute } from "../../components/auth/SecureRoute";

import { withCompass } from "../../components/compass/withCompass";
const ImageEnrichmentNudgesPage = lazy(
  () => import("../../pages/ImageEnrichmentNudgesPage")
);
const PDPChatMissingDetailsPage = withCompass(
  () => import("../../pages/PDPChatMissingDetails")
);
const BrandNudgesBrandMessagesPage = lazy(
  () =>
    import("../../pages/BrandNudgesMissingDetailsPDPChatMessages/BrandNudgesBrandMessagesPage")
);
const BrandNudgesMissingDetailsPDPChatMessagesPage = lazy(
  () => import("../../pages/BrandNudgesMissingDetailsPDPChatMessages")
);
const BrandNudgesProductEditorPage = lazy(
  () =>
    import("../../pages/BrandNudgesMissingDetailsPDPChatMessages/BrandNudgesProductEditorPage")
);

export function OliviaOlearyRoutes() {
  return (
    <Switch>
      <Route
        path="/oo/pdp-chat-missing-details"
        component={PDPChatMissingDetailsPage}
      />
      <Route
        path="/oo/brand-nudges-missing-details-pdp-chat-messages"
        render={({ match }: { match: any }) => (
          <Switch>
            <SecureRoute
              path={`${match.path}/product-editor`}
              render={() => <BrandNudgesProductEditorPage />}
            />
            <SecureRoute
              path={`${match.path}/messages`}
              render={() => <BrandNudgesBrandMessagesPage />}
            />
            <SecureRoute
              exact
              path={match.path}
              render={() => <BrandNudgesMissingDetailsPDPChatMessagesPage />}
            />
          </Switch>
        )}
      />
      <Route
        path="/oo/image-enrichment-nudges"
        component={ImageEnrichmentNudgesPage}
      />
    </Switch>
  );
}

export const slug = "oo";
